import { Tooltip } from '@vtex/admin-ui'
import { FormattedMessage, useIntl } from 'react-intl'
import type { Installments as InstallmentsType } from 'typings'
import { Tag } from 'ui'
import { messages } from './messages'

type InstallmentsProps = {
  installments: InstallmentsType | undefined
}

export function Installments(props: InstallmentsProps) {
  const { $t, formatNumber } = useIntl()
  const { installments } = props

  if (!installments) return null

  const { min, max } = installments

  if (min === undefined && max === undefined) return null

  const processTooltip = () => {
    if (min !== undefined && max === undefined) {
      return $t(
        { ...messages.installments.min },
        {
          min: formatNumber(min),
        }
      )
    }

    if (min === undefined && max !== undefined) {
      return $t(
        { ...messages.installments.max },
        {
          max: formatNumber(max),
        }
      )
    }

    if (min !== undefined && max !== undefined) {
      return $t(
        { ...messages.installments.range },
        {
          max: formatNumber(max),
          min: formatNumber(min),
        }
      )
    }

    return ''
  }

  return (
    <Tooltip text={processTooltip()}>
      <Tag>
        <FormattedMessage {...messages.installments.title} />
      </Tag>
    </Tooltip>
  )
}
